import { OpportunityResponseWithId, allSpecObjectsBySlug } from '@fullstory/redux';
import {
  ImpactAnalytics,
  ImpactAnalyticsContext,
  OpportunitiesAnalyticsContext,
} from '@fullstory/redux/modules/impacts/actions/impacts';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  trackConversionAnalysisRun,
  trackGenerateOpportunitiesFailed,
  trackGenerateOpportunitiesStarted,
  trackGenerateOpportunitiesSuccess,
} from './trackers';
import { AnalysisOrigin } from './types';
import {
  conversionsAnalysisRun,
  transformGenerateOpportunitiesSuccess,
  transformOpportunitiesRequest,
} from './util';

// Helper to give the correct shape of the `ImpactAnalytics`, which is used for conditional analytics tracking throughout all of
// generateSignalsAndFunnels, which also calls the opportunity related analytics.
export const useConversionsAnalytics = (origin: AnalysisOrigin): ImpactAnalytics => {
  const specObjects = useSelector(allSpecObjectsBySlug);

  return useMemo(
    () => ({
      conversionsAnalysisRun: (params: ImpactAnalyticsContext) => {
        trackConversionAnalysisRun(
          conversionsAnalysisRun({
            origin,
            specObjects,
            ...params,
          }),
        );
      },
      opportunitiesStarted: (params: OpportunitiesAnalyticsContext) => {
        trackGenerateOpportunitiesStarted({
          request: transformOpportunitiesRequest(params),
          batchId: params.requestId,
          requestId: params.requestId,
        });
      },
      opportunitiesFailed: (
        params: OpportunitiesAnalyticsContext & {
          status: number;
        },
      ) => {
        trackGenerateOpportunitiesFailed({
          request: transformOpportunitiesRequest(params),
          requestId: params.requestId,
          status: params.status,
        });
      },
      opportunitiesSucceeded: (
        params: OpportunitiesAnalyticsContext & {
          resp: OpportunityResponseWithId;
        },
      ) => {
        trackGenerateOpportunitiesSuccess({
          ...transformGenerateOpportunitiesSuccess(params.resp),
          request: transformOpportunitiesRequest(params),
          requestId: params.requestId,
        });
      },
    }),
    [specObjects, origin],
  );
};
